import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const MerchCard = ({ item, index }) => {
  const images = [item.image_url, item.image_url_2].filter(Boolean);
  const hasMulti = images.length > 1;
  const labels = item.main_is_back ? ["Back", "Front"] : ["Front", "Back"];
  const [idx, setIdx] = useState(0);

  const next = (e) => {
    e?.stopPropagation();
    setIdx((i) => (i + 1) % images.length);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }} transition={{ delay: index * 0.1 }}
      className="group border border-white/10 bg-[color:var(--bg-void)] overflow-hidden hover:border-[color:var(--alien)] transform-gpu hover:-translate-y-1 duration-300"
      data-testid={`merch-card-${index}`}
    >
      <button
        type="button"
        onClick={hasMulti ? next : undefined}
        onMouseEnter={hasMulti ? () => setIdx(1) : undefined}
        onMouseLeave={hasMulti ? () => setIdx(0) : undefined}
        aria-label={hasMulti ? "Cambia foto" : item.name}
        data-testid={`merch-card-${index}-image`}
        className="relative aspect-square overflow-hidden block w-full cursor-pointer"
      >
        <AnimatePresence mode="wait">
          <motion.img
            key={idx}
            src={images[idx] || ""}
            alt={item.name}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
            className="w-full h-full object-cover absolute inset-0 group-hover:scale-105 transition-transform duration-500"
          />
        </AnimatePresence>

        {hasMulti && (
          <>
            <div className="absolute top-3 right-3 bg-black/70 border border-white/20 px-2 py-1 text-[10px] uppercase tracking-widest text-white/80" data-testid={`merch-card-${index}-side`}>
              {labels[idx]}
            </div>
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
              {images.map((_, i) => (
                <span
                  key={i}
                  className={`h-1.5 w-1.5 rounded-full transition-colors ${i === idx ? "bg-[color:var(--alien)]" : "bg-white/30"}`}
                />
              ))}
            </div>
          </>
        )}
      </button>
      <div className="p-5">
        <div className="flex items-baseline justify-between">
          <h3 className="font-display text-2xl">{item.name}</h3>
          {item.price_hint && <span className="text-[color:var(--alien)] font-display text-xl">{item.price_hint}</span>}
        </div>
        {item.is_new && (
          <span className="inline-block mt-2 bg-[color:var(--alien)] text-black text-[10px] font-bold uppercase tracking-[0.2em] px-2 py-1" data-testid={`merch-card-${index}-new-badge`}>
            ★ Nuovo Arrivo
          </span>
        )}
        <p className="text-white/60 text-sm mt-2">{item.description}</p>
        {item.sizes && <p className="text-white/40 text-xs mt-3 uppercase tracking-widest">Taglie: {item.sizes}</p>}
        {!item.available && <p className="text-red-400 text-xs mt-2 uppercase tracking-widest">Esaurito</p>}
      </div>
    </motion.div>
  );
};
